import { orgTypes } from 'utils/roles-sectors';

export const getOrganizationTypeLabel = (name) => {
  const result = orgTypes.find((item) => item.name === name);
  return result != null ? result.label : `ERROR ${name}`;
};

export const getLabel = (name, options, key = 'name') => {
  const result = options.find((item) => item[key] === name);
  return result != null ? result.label : `ERROR ${name}`;
};
